//<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">

        <Toolbar class="p-mb-4">
          <template #start>
            <div style="font-size: 1.4em; color: inherit" class="p-mr-3">{{ $t('SMS Messages') }}</div>
<!--            <AddNewButton :label="$t('Add')" @click="addNewItem" />-->
          </template>
<!--          <template #end>-->
<!--          </template>-->
        </Toolbar>

        <!--  Desktop DataTable -->
        <Spinner v-if="isLoading"/>
<!--        <DesktopDataTable v-else-if="!isLoading && !$store.state.tabletLayout"-->
        <DesktopDataTable v-else
                          :dataTableIsLoading="dataTableIsLoading"
                          :showHeader="false"
                          :itemsArrayIsEmpty="itemsArrayIsEmpty"
                          :sort="sort"
                          :showButtons="!!actionButtonsCount"
                          :showSearchInput="false"
                          :actionButtonsCount="actionButtonsCount"
                          @sort-items="sortItems"
                          :headers="[
              {name: 'id', title: 'ID',sortable: false},
              {name: 'tenant', title: 'Tenant',sortable: false},
              {name: 'location', title: $t('Location'),sortable: false},
              {name: 'Customer', title: $t('Customer'),sortable: false},
              {name: 'to_phone', title: $t('Phone'), sortable: false},
              {name: 'from_name', title: $t('Sender Name'), sortable: false},
              {name: 'text', title: 'Text', sortable: false},
              {name: 'state', title: $t('Status'), sortable: false},
              {name: 'status', sortable: false},
              {name: 'cost', title: $t('Price'), sortable: false},
              {name: 'count', title: $t('Count'), sortable: false},
              {name: 'error_message', title: $t('Error'), sortable: false},
              {name: 'sent_at', title: $t('sentAtLabel'), sortable: false},
              // {name: 'created_at', title: $t('Created'), sortable: false},

          ]">
          <template v-slot:body>
            <tr v-for="(item, index) of items"
                :key="index"
                :class="{'updated-item': isItemUpdated(item.id)}">
              <td>{{ item.id }}</td>
              <td>
                <span v-if="item.tenant?.name">{{ item.tenant.name }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.location?.public_name">{{ item.location.public_name }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.user">
                  <span v-if="item.user.type === 1">{{ item.user.first_name }} {{ item.user.last_name }}</span>
                  <span v-if="item.user.type === 2">{{ item.user.company_name }}</span>
                </span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.to_phone">{{ item.to_phone }}</span>
                <i v-else class="ti-minus"/>
              </td>

              <td>
                <span v-if="item.from_name">{{ item.from_name }}</span>
                <i v-else class="ti-minus"/>
              </td>

              <td>
                <span v-if="item.text">{{ item.text }}</span>
                <i v-else class="ti-minus"/>
              </td>

              <td>
                <span v-if="item.state">
                  <span v-if="item.state === 1">NEW</span>
                  <span v-else-if="item.state === 3">SENT</span>
                  <span v-else-if="item.state === 9">ERROR</span>
                </span>
                <i v-else class="ti-minus"/>
              </td>

              <td>
                <span v-if="item.status">{{ item.status }}</span>
                <i v-else class="ti-minus"/>
              </td>

              <td>
                <span v-if="item.cost">{{ formatCurrency(item.cost, 4, 4) }}</span>
                <i v-else class="ti-minus"/>
              </td>

              <td>
                <span v-if="item.count">{{ item.count }}</span>
                <i v-else class="ti-minus"/>
              </td>

              <td>
                <span v-if="item.error_message">{{ item.error_message }}</span>
                <i v-else class="ti-minus"/>
              </td>

              <td>
                <span v-if="item.sent_at">{{ formatDate(item.sent_at, true)}}</span>
                <i v-else class="ti-minus"/>
              </td>

<!--              <td class="table-date-line">-->
<!--                {{ formatBy(item.notification?.created_at, item.notification?.creator) }}-->
<!--              </td>-->
<!--              <td v-show="actionButtonsCount">-->
<!--                <div class="p-d-flex p-jc-end">-->
<!--                  <DeleteButton @click="confirmItemDelete({id: item.id, name: item.name})"-->
<!--                                :disabled="dataTableIsLoading"-->
<!--                                v-show="$store.getters.isAdminOrSuperAdmin"/>-->
<!--                </div>-->
<!--              </td>-->
            </tr>
          </template>
        </DesktopDataTable>

        <OwnPaginator v-show="!itemsArrayIsEmpty"
                      :rows="pagination.perPage"
                      :currentPage="pagination.currentPage - 1"
                      :totalPages="pagination.pageCount"
                      :totalRecords="pagination.totalCount"
                      :rowsPerPageOptions="[5,10,25,50,100,200]"
                      :pageLinkSize="11"/>

        <TotalRecordsData :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>
			</div>
		</div>
	</div>
</template>

<script>
import httpClient from '@/services/http.services'
import formatMixins from "@/mixins/formatMixins";
import datatableMixins from "@/mixins/datatableMixins";
import settings from "@/settings";
import NotificationTypes from "@/translations/NotificationTypes";
import showErrorsMixins from "@/mixins/showErrorsMixins";

export default {
  mixins: [ formatMixins, datatableMixins, showErrorsMixins ],
	data() {
		return {
      // fieldsExpand: 'tenant,location,creator,user,notification.creator',
      fieldsExpand: 'tenant,location,creator,user',
      apiLink: 'sms-message',
      routePath: '/sms-messages',
      searchData: '',
      sort: {
        column: 'id',
        direction: '-',
      },
      NotificationTypes,
		}
	},
  mounted() {
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.checkRouteQuery()
    this.getPageData()
	},
  methods: {
    getPageData() {
      this.getItems()
    },
    async getItems() {
      if (!this.userCanGetData || this.fetchInFlight) return
      this.$store.commit('SET_FETCH_IN_FLIGHT', true)
      this.dataTableIsLoading = true
      const ctrl = this.setController?.('smsMessages')
      try {
        const { status, data, headers } = await httpClient({
          url: this.apiLink,
          // method: 'get',
          params: {
            type: this.selectedTypeId,
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.searchData,
            expand: this.fieldsExpand,
          },
          signal: ctrl?.signal
        })
        // console.log(data)
        // const { status, data, headers } = await httpClient(`${this.apiLink}?page=${this.pagination.currentPage}&per-page=${this.pagination.perPage}&sort=${this.sort.direction + this.sort.column}&search=${this.searchData}&expand=${this.fieldsExpand}`)
        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          if (!data.length) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.dataTableIsLoading = false
        this.isLoading = false
        if (this._abortors?.smsMessages === ctrl) {
          this._abortors.smsMessages = null
        }
      }
    },
	},
  computed: {
    actionButtonsCount() {
      return 0
    },
  }
}
</script>

<style scoped lang="scss">

</style>